import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ResponseStatus } from '@store';

import { PillType } from '../../../../shared/components/pill/pill.model';

@Pipe({
  name: 'partnerAccessSharePillPipe',
})
export class PartnerAccessSharePillPipePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(status: ResponseStatus): { type: PillType; text: string } {
    let result: { type: PillType; text: string };

    switch (status) {
      case ResponseStatus.Loading:
        result = {
          type: PillType.neutral,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_STATUS_SENDING'
          ),
        };
        break;
      case ResponseStatus.Success:
        result = {
          type: PillType.success,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_STATUS_SUCCESS'
          ),
        };
        break;
      case ResponseStatus.Error:
        result = {
          type: PillType.error,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_STATUS_ERROR'
          ),
        };
        break;
    }

    return result;
  }
}
